'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = {
    year: '年',
    month: '月',
    day: '日',
    hour: '时',
    minute: '分',
    am: '上午',
    pm: '下午'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/rmc-date-picker/lib/locale/zh_CN.js
// module id = 1066
// module chunks = 0